'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'camera-rotate';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0d8';
var svgPathData = 'M144.9 55.8C153.5 41.1 169.3 32 186.4 32l139.2 0c17.1 0 32.9 9.1 41.5 23.8L390.5 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l57.5 0 23.4-40.2zM186.4 64c-5.7 0-11 3-13.8 7.9l-28.1 48.1c-2.9 4.9-8.1 7.9-13.8 7.9L64 128c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-66.7 0c-5.7 0-11-3-13.8-7.9L339.4 71.9c-2.9-4.9-8.1-7.9-13.8-7.9L186.4 64zM101.6 267.9c6.7-5.8 16.8-5 22.6 1.7l19.9 23.2 0-20.7c0-61.9 50.1-112 112-112 13.9 0 27.3 2.5 39.6 7.2l-23.5 26.4c-5.2-1.1-10.6-1.6-16.1-1.6-44.2 0-80 35.8-80 80l0 20.7 19.9-23.2c5.8-6.7 15.9-7.5 22.6-1.7s7.5 15.8 1.7 22.6l-48 56c-3 3.5-7.5 5.6-12.1 5.6s-9.1-2-12.1-5.6l-48-56c-5.8-6.7-5-16.8 1.7-22.6zm214.6 6.6c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l48-56c3-3.5 7.5-5.6 12.1-5.6s9.1 2 12.1 5.6l48 56c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L368 251.3 368 272c0 61.9-50.1 112-112 112-13.9 0-27.3-2.5-39.6-7.2l23.5-26.4c5.2 1.1 10.6 1.6 16.1 1.6 44.2 0 80-35.8 80-80l0-20.7-19.9 23.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCameraRotate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;